<div class="wrapper">
    <!-- <div class="page-header page-header-small">
        <div class="page-header-image " data-rellax-speed="-8" style="background-image: url('assets/img/bg-landing1.avif'); background-position: -20%;">
        </div>
        <div class="container">
            <div class="content-center">
                <h1 class="title" style="margin-top: 150px;">Benvenuti nel portale Centro Funzionale Multirischi</h1>
            </div>
        </div>
    </div> -->
    <!-- Sezione widget -->
    <div class="">
        <ngb-carousel class="carousel-landing" [showNavigationArrows]="true" [showNavigationIndicators]="true"
            [interval]="0">
            <!-- Widget 1 - zone -->
            <!-- >768 -->
            <ng-template style="height: 700px;" ngbSlide>
                <div class="w-100 d-flex justify-content-center" style="height: 600px;">
                    <div class="d-flex container container-wd-3 w-100">
                        <!-- selezione -->
                        <div class="selezione d-flex justify-content-center mr-2">
                            <button class="meteo-button mb-4 btn d-flex flex-column justify-content-center"
                                (click)="selezionaMeteo(1)"
                                [ngClass]="{ 'selected': tipoMeteo == 1 ,'btn-secondary color-bianco-testo example-4': lungOggi == 0 && checkOggi ==false,'bg-green color-bianco-testo': lungOggi == 0 || ultimoAllertamentoOggi.livello == 1, 'bg-orange color-black': ultimoAllertamentoOggi.livello == 2, 'bg-red-light color-bianco-testo': ultimoAllertamentoOggi.livello == 3, 'bg-red color-bianco-testo': ultimoAllertamentoOggi.livello == 4 }">
                                <span class="h6 mb-1">Stato di Allerta ATTUALE</span>
                                <span *ngIf="lungOggi >0" class="h3 m-0" [innerHTML]="formatLivelloDesc(ultimoAllertamentoOggi.livelloDesc)"></span>
                                <span *ngIf="lungOggi == 0 && checkOggi == true" class="h3 m-0">
                                    Livello di allerta <br/>
                                    idrogeologica e/o idraulica <br/>
                                    VERDE<br/>
                                </span>
                                <span *ngIf="lungOggi == 0 && checkOggi ==false" class="h3 m-0">
                                    Livello di allerta <br/>
                                    idrogeologica e/o idraulica <br/>
                                    IN FASE DI VALUTAZIONE</span>
                                <span class="disclaimer-data"
                                    *ngIf="rifBollettinoOggi?.dataDa && rifBollettinoOggi?.dataA; else noDataOggi">
                                     Valido dalle {{ rifBollettinoOggi.dataDa }} <br/> alle {{ rifBollettinoOggi.dataA }}
                                </span>
                                <ng-template #noDataOggi>-</ng-template>
                            </button>
                            <button class="meteo-button btn d-flex flex-column justify-content-center"
                                [ngClass]="{ 'selected': tipoMeteo == 2 ,'btn-secondary color-bianco-testo example-4': lungDomani == 0 && checkDomani ==false,'bg-green color-bianco-testo': lungDomani == 0 && checkDomani ==true || ultimoAllertamentoDomani.livello == 1, 'bg-orange color-black': ultimoAllertamentoDomani.livello == 2, 'bg-red-light color-bianco-testo': ultimoAllertamentoDomani.livello == 3, 'bg-red color-bianco-testo': ultimoAllertamentoDomani.livello == 4 }"
                                (click)="selezionaMeteo(2)"> 
                                <span class="h6 mb-1">Stato di Allerta PREVISTO</span>
                                <!-- <span class="h3 m-0 bottone-dettaglio">Stato allerta</span> -->
                                <span *ngIf="lungDomani >0"
                                    class="h3 m-0" [innerHTML]="formatLivelloDesc(ultimoAllertamentoDomani.livelloDesc)">
                                </span>
                                <span class="disclaimer-data"
                                    *ngIf="lungDomani > 0">
                                    Valido dalle {{ rifBollettinoDomani.dataDa }} <br> alle {{ rifBollettinoDomani.dataA }}
                                </span>

                                <span *ngIf="lungDomani == 0 && checkDomani ==true" class="h3 m-0">
                                    Livello di allerta<br/>
                                    idrogeologica e/o idraulica <br/>
                                    VERDE
                                </span>
                               
                                <span class="disclaimer-data"
                                    *ngIf="lungDomani == 0 && checkDomani ==true">
                                    Valido dalle {{ rifBollettinoDomani.dataDa }} <br> alle {{ rifBollettinoDomani.dataA }}
                                </span>

                                <span *ngIf="lungDomani == 0 && checkDomani ==false" class="h3 m-0">
                                    Livello di allerta<br>
                                    idrogeologica e/o idraulica <br> 
                                    IN FASE DI VALUTAZIONE
                                </span>
                                
                                <span class="disclaimer-data"
                                    *ngIf="lungDomani == 0 && checkDomani ==false"> 
                                    Dalle {{ rifBollettinoDomani.dataDa }} 
                                </span>
                                <ng-template #noDataDomani>-</ng-template>
                            </button>
                        </div>
                        <!-- risultato -->
                        <div class="risultato d-flex">
                            <div class="w-100 meteo-result-container">
                                <widget-mappa-allerta *ngIf="tipoMeteo == 1" rifBollettino="1"></widget-mappa-allerta>
                                <widget-mappa-allerta *ngIf="tipoMeteo == 2" rifBollettino="2"></widget-mappa-allerta>
                            </div>
                        </div>
                    </div>
                </div>

            </ng-template>
            <!-- Widget 2 - prev oggi -->
            <ng-template ngbSlide>
                <div class="w-100 d-flex flex-column justify-content-center" style="height: 600px; ">
                    <div class="d-flex container w-75 h-75 p-3 justify-content-around"
                        style="background-color: white; border-radius: 25px;">
                        <!-- <div class="h-100 col-md-3 pt-2 d-flex flex-column">
                            <span class="w-100 h5 mb-2">Mattina</span>
                            <div class="widget-img"></div>
                        </div>
                        <div class="h-100 col-md-3 pt-2 d-flex flex-column">
                            <span class="w-100 h5 mb-2">Pomeriggio</span>
                            <div class="widget-img"></div>
                        </div>
                        <div class="h-100 col-md-3 pt-2 d-flex flex-column">
                            <span class="w-100 h5 mb-2">Sera</span>
                            <div class="widget-img"></div>
                        </div> -->
                        <app-widget-previsioni></app-widget-previsioni>
                    </div>
                    <!-- <div class="carousel-caption">
                        <h3>elemento 1</h3>
                    </div> -->
                </div>
            </ng-template>
            <!-- Widget 3 - tabella -->
            <!-- <ng-template ngbSlide>
                <div class="w-100 d-flex flex-column justify-content-center" style="height: 600px; ">
                    <div class="d-flex container w-75 h-75 p-3 justify-content-around" style="background-color: white; border-radius: 25px;">
                        <app-widget-tabella></app-widget-tabella>
                    </div>
                    <div class="carousel-caption">
                        <h3>elemento 1</h3>
                    </div>
                </div>
            </ng-template> -->
        </ngb-carousel>
    </div>
    <!-- Prima sintesi -->
    <div class="section section-team text-center">
        <div class="d-flex flex-column px-2">
            <div class="team container">
                <div class="row">
                    <div class="col-md-8 d-flex flex-column justify-content-center">
                        <span class="h2 titolo-dark"><b>Centro Funzionale Multirischi</b></span>
                        <div class="text-container">
                            <div class="text-content" [innerHTML]="descrizioneSezione"></div>
                            <div class="gradient-overlay"></div>
                        </div>

                        <a routerLink="/chi-siamo" class="read-more-btn">Scopri di più</a>

                    </div>
                    <div class="image-container col-md-4">
                        <img src="../../../assets/images/chi-siamo-protezione-civile.jpg" class="chi-siamo-cover">
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- News -->
    <div class="section section-team text-center last-news-section">
        <div class="d-flex flex-column px-2">
            <div class="team container">
                <div class="pl-5 mb-2">
                    <h2 class="title mb-3" style="text-align: start !important;">Ultime news</h2>
                </div>
                <div class="row">
                    <div class="col-md-8 col-sm-12">
                        <ta-comunicazioni class="d-flex"></ta-comunicazioni>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <ta-allerta-download></ta-allerta-download>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>